import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { Popover } from 'react-tiny-popover';

import Input from '../../../../components/Form/Input';
import Button from '../../../../components/Button';
import { maskCurrency, unmaskCurrency } from '../../../../utils/masks';
import { nextAction } from '../../../../saga/actions/workflow';
import { getHTTPErrorMessage } from '../../../../utils/fetch';
import { getNextUrl } from '../url';

const Step1 = (props) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  // get functions to build form with useForm() hook
  const hookForm = useForm({ reValidateMode: 'onSubmit' });
  const { handleSubmit, setValue } = hookForm;

  // set initial values
  const requestedAmount = get(props.workflow, 'data.data.requestedAmount');
  useEffect(() => {
    setValue('requestedAmount', requestedAmount);
  }, [requestedAmount, setValue]);

  // handle functions
  const onSubmit = (data) => {
    props.nextAction({
      url: getNextUrl(),
      method: 'PUT',
      data: {
        requestedAmount: unmaskCurrency(data.requestedAmount),
      },
    });
    return false;
  };
  const validateAmount = (val) => {
    const value = unmaskCurrency(val);
    if (!value) {
      return 'This input field is required';
    }
    if (value < 1000 || value > 47500) {
      return 'The amount must be between $1,000 and $47,500';
    }
    return null;
  };

  const errorMsg = getHTTPErrorMessage(props.workflow.error);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="text-center md:text-left font-bold text-[26px] leading-[26px] md:text-[32px] md:leading-[38px] text-[#263952]">
        Let’s get started
        <br />
        {' '}
        It only takes a few minutes!
      </div>
      <div className="text-center md:text-left font-normal text-[15px] leading-[20px] text-[#263952] mt-[8px] ">
        This won’t affect your credit score
        {' '}
        <sup>1</sup>
      </div>
      <div className="text-center md:text-left font-medium text-[18px] leading-[32px] text-black mt-[53px]">
        How much do you need to borrow?
      </div>

      <Input
        autoFocus
        name="requestedAmount"
        label="Loan Amount"
        placeholder="$ "
        className="w-full md:w-2/3"
        isMasked={maskCurrency}
        hookForm={hookForm}
        validate={validateAmount}
      />
      <div className="text-left font-normal text-[12px] leading-[16px] text-[#959595] mt-[17px]">Enter an amount between $1,000 and $47,500</div>
      <div className="text-left font-medium text-[14px] leading-[16px] text-black mt-[20px]">
        Important information about procedures for opening a new account;
        <Popover
          isOpen={isPopoverOpen}
          positions={['top']} // preferred positions by priority
          align="start"
          padding={10}
          onClickOutside={() => setIsPopoverOpen(false)}
          content={(
            <>
              <div className="rounded-md border border-[#00214732] p-5 bg-[#ffffff] m-auto max-w-[90%] md:max-w-[400px] max-h-[500px] overflow-y-auto text-[#3f556e] text-[14px]">
                <p>To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.</p>
                <p>What this means for you: When you open an account, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver&apos;s license or other identifying documents.</p>
              </div>
              <span className="arrow left-2 hidden md:block" />
            </>
          )}
        >
          <span className="underline cursor-pointer pr-1 text-[#3989e3] ml-1" onClick={() => setIsPopoverOpen(!isPopoverOpen)}>USA PATRIOT Act Notice</span>
        </Popover>
      </div>
      <Button isLoading={props.workflow.isLoading} type="submit" className="w-full md:w-[240px]">Continue</Button>
      {errorMsg && <div className="mt-3 mb-3 text-[#d71f28] text-xs">{errorMsg}</div>}
    </form>
  );
};

Step1.propTypes = {
  workflow: PropTypes.object.isRequired,
  nextAction: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => ({
      workflow: state.workflow,
    }),
    {
      nextAction,
    }
  )
)(Step1);
